import { useState, useCallback } from 'react';
import useWebSocket from 'react-use-websocket';

function useLastConfTime() {
  const [lastConfTime, setLastConfTime] = useState(null);

  const { sendMessage, lastMessage, readyState } = useWebSocket(process.env.REACT_APP_WS, {
    onMessage: function (event) {
      const data = JSON.parse(event.data);
      if (data['lastConfTime'] !== undefined) {
        setLastConfTime(data['lastConfTime']);
      }
    },
    share: true,
    shouldReconnect: (closeEvent) => true,
  });

  return {
    lastConfTime,
    sendMessage,
    lastMessage,
    readyState
  };
}

export default useLastConfTime;